import { render, staticRenderFns } from "./notifyMenu.vue?vue&type=template&id=4a7e0bcc&scoped=true"
import script from "./notifyMenu.vue?vue&type=script&lang=js"
export * from "./notifyMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7e0bcc",
  null
  
)

export default component.exports